module.exports = __webpack_public_path__ + "static/media/client-background.e746e09b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client-background.png
// module id = 46
// module chunks = 0